import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={46}
    height={45}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.2} cx={23} cy={22.5} r={22.5} fill="#C4C4C4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.46 21.166 19.58 31.354c-1.402 2.43-4.439.676-3.036-1.753l5.882-10.188c-2.236-3.45-.335-7.21 3.578-7.29l-1.012 1.755c-1.91 3.306 2.14 5.643 4.048 2.337l1.013-1.754c2.07 3.894-.418 6.956-4.591 6.705Zm-5.58 7.484-.856 1.484c-.507.877-1.654.215-1.147-.662l.857-1.484c.506-.878 1.653-.215 1.147.662Z"
      fill="#000"
    />
  </svg>
);

export default SvgComponent;
